import { useLayoutEffect, useState } from 'react';

import { cookieConsent } from 'config/common';

import { getCookieValue } from 'utility/Track/cookies';

export enum ConsentType {
    Functional = 'f',
    Analytic = 'a',
    Marketing = 'm',
}

const useConsent = (): Record<ConsentType, boolean> => {
    const [valueFromCookie, setValueFromCookie] = useState(
        getCookieValue(cookieConsent.cookieId)
    );

    const handleConsentEvent = () =>
        setValueFromCookie(getCookieValue(cookieConsent.cookieId));

    useLayoutEffect(() => {
        window.addEventListener(cookieConsent.consentEvent, handleConsentEvent);

        return () => {
            window.removeEventListener(
                cookieConsent.consentEvent,
                handleConsentEvent
            );
        };
    }, []);

    return {
        [ConsentType.Functional]:
            valueFromCookie.indexOf(ConsentType.Functional) > -1,
        [ConsentType.Analytic]:
            valueFromCookie.indexOf(ConsentType.Analytic) > -1,
        [ConsentType.Marketing]:
            valueFromCookie.indexOf(ConsentType.Marketing) > -1,
    };
};

export default useConsent;
